import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { reactive, onMounted, toRefs, watch, watchEffect, getCurrentInstance, ref } from "vue";
import apis from "@/api";
import { useRouter } from 'vue-router';
import dayjs from 'dayjs';
import { srcType } from "@/utils/srcType";
export default {
  props: {
    id: String
  },
  components: {},
  setup(props, ctx) {
    let data = reactive({
      positionId: "",
      queryParam: {
        actName: "",
        assetsName: "",
        bgnDate_begin: "",
        endDate_end: ""
      },
      tabNum: "1",
      pageSize: 10,
      pageNo: 1,
      loading: true,
      tableData: [],
      tableTotal: 0,
      dateRange: '',
      defaultTime: [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)],
      selectedIds: [],
      srcType: srcType,
      check: false,
      checkedAssetSet: new Set()
    });
    const router = useRouter();
    const loadData = () => {
      data.loading = true;
      data.tableData = [];
      let params = Object.assign({}, data.queryParam, {
        positionId: data.positionId,
        tab: data.tabNum,
        pageNo: data.pageNo,
        pageSize: data.pageSize
      });
      apis.queryOffLPosBizList(params).then(res => {
        if (res.success) {
          data.tableData = res.data.pageList.records;
          data.tableTotal = res.data.pageList.total;
          if (data.tableData.length > 0) {
            if (data.check) {
              // 全选
              data.tableData.forEach(item => {
                data.checkedAssetSet.add(item.id);
                item.checked = true;
              });
            } else {
              // 不全选
              data.tableData.forEach(item => {
                item.checked = false;
              });
            }
            console.log(data.checkedAssetSet, "data.checkedAssetSet");
          }
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        data.loading = false;
      });
    };
    watch(() => props.id, id => {
      data.positionId = id;
      console.log(data.positionId, "watch");
      loadData();
    }, {
      immediate: true
    });
    const dateRangeChange = e => {
      data.queryParam.bgnDate_begin = dayjs(e[0]).format("YYYY-MM-DD HH:mm:ss");
      data.queryParam.endDate_end = dayjs(e[1]).format("YYYY-MM-DD HH:mm:ss");
    };
    const onSubmit = () => {
      loadData();
    };
    const reset = () => {
      data.queryParam = {
        actName: "",
        assetsName: "",
        bgnDate_begin: "",
        endDate_end: ""
      };
      data.dateRange = '';
      loadData();
    };
    const putAsset = (p, posBizId) => {
      if (posBizId) {
        router.push(`/operation/offline/off-position-biz-put?id=${posBizId}&opType=${p}`);
      } else {
        router.push(`/operation/offline/off-position-biz-put?posId=${data.positionId}&opType=${p}`);
      }
    };

    /**
     * 批量通知
     */
    const sendNotice = () => {
      if (data.checkedAssetSet.size == 0) {
        ElMessage.warning("请至少选择一条数据");
        return;
      }
      apis.batchSendNotice(Array.from(data.checkedAssetSet).join(',')).then(res => {
        if (res.success) {
          ElMessage.success("通知已下发");
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const handleClick = (tab, event) => {
      data.tabNum = tab.props.name;
      loadData();
    };
    const showDetail = row => {
      router.push(`/operation/offline/off-position-biz-info?id=${row.id}`);
    };
    const handleSizeChange = val => {
      console.log(`每页 ${val} 条`);
      data.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      console.log(`当前页: ${val}`);
      data.pageNo = val;
      loadData();
    };
    const handleSelectionChange = val => {
      if (val.length > 0) {
        let ids = [];
        val.forEach(item => {
          ids.push(item.id);
        });
        data.selectedIds = ids;
      }
    };
    // 开启选择模式
    const checkModel = () => {
      data.check = true;
    };
    // 全选，取消
    const checkedAll = p => {
      data.check = p;
      if (p) {
        data.tableData.forEach(item => {
          data.checkedAssetSet.add(item.id);
          item.checked = true;
        });
      } else {
        data.checkedAssetSet.clear();
        data.tableData.forEach(item => {
          item.checked = false;
        });
      }
      console.log(data.checkedAssetSet, "data.checkedAssetSet");
    };
    // 单选，取消
    const checked = id => {
      if (data.check) {
        // 选择模式
        console.log(id, "checked id");
        data.tableData.forEach(item => {
          if (item.id == id) {
            if (item.checked) {
              data.checkedAssetSet.delete(item.id);
              item.checked = false;
            } else {
              data.checkedAssetSet.add(item.id);
              item.checked = true;
            }
          }
        });
        console.log(data.checkedAssetSet, "data.checkedAssetSet");
      }
    };
    return {
      ...toRefs(data),
      onSubmit,
      reset,
      putAsset,
      loadData,
      handleClick,
      handleSizeChange,
      handleSelectionChange,
      handleCurrentChange,
      dateRangeChange,
      showDetail,
      sendNotice,
      checkModel,
      checkedAll,
      checked
    };
  }
};